import PortfolioIcon from '@/components/icons/portfolioIcon';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
// InsightsOutlinedIcon removed in favor of AnalyticsOutlinedIcon for BI
import { NavigationItem } from '.';

export const InvestorIconMap: Record<string, React.ReactNode> = {
  'fa-home': <DashboardOutlinedIcon />,
  'fa-columns': <AccountBalanceOutlinedIcon />,
  'fa-usd': <PortfolioIcon />,
  'fa-credit-card': <CreditCardOutlinedIcon />,
  'fa-users': <GroupOutlinedIcon />,
  // "fa-files-o": <DescriptionOutlinedIcon />,
  'fa-line-chart': <AnalyticsOutlinedIcon />,
  'fa-cog': <BuildOutlinedIcon />,
  'fa-folder': <FolderOutlinedIcon />,
  'fa-list-alt': <AccountCircleOutlinedIcon />,
  'fa-user': <PersonOutlineOutlinedIcon />,
  'fa-address-card': <ContactPageOutlinedIcon />,
  'fa-check': <TaskAltOutlinedIcon />,
  '/Team': <ContactPageOutlinedIcon />,
  '/Analytics': <AnalyticsOutlinedIcon />,
  '/Documents': <DescriptionOutlinedIcon />,
  '/Advisor/Wealth': <AccountBalanceOutlinedIcon />,
};

const investorNavItems: NavigationItem[] = [
  {
    text: 'Dashboard',
    route: '/dashboard',
    icon: <DashboardOutlinedIcon />,
  },
  {
    text: 'Balance Sheet',
    route: '/balance-sheet',
    icon: <AccountBalanceOutlinedIcon />,
  },
  {
    text: 'Portfolio',
    icon: <PortfolioIcon />,
    children: [
      { text: 'Accounts', route: '/portfolio/accounts' },
      { text: 'Holdings', route: '/portfolio/holdings' },
      { text: 'Asset Allocation', route: '/portfolio/asset-allocation' },
      { text: 'Investment Activity' },
      { text: 'Market Pricing' },
    ],
  },
  {
    text: 'Cash Flow',
    route: '/cash-flow',
    icon: <CompareArrowsOutlinedIcon />,
  },
  {
    text: 'Documents',
    icon: <DescriptionOutlinedIcon />,
    children: [
      { text: 'Document Vault', route: 'documents/document-vault' },
      { text: 'Reports' },
    ],
  },
  {
    text: 'Financial Team',
    route: '/team',
    icon: <GroupOutlinedIcon />,
  },
];

export default investorNavItems;
